import React from 'react';
import _ from "underscore";

import attributeIds from "../../../api/attributeIds";

import "../../../css/LocationDetail.css";

var MedicationsAvailableDetailWidget = (props) =>{
    return (
        <div className="medicationsAvailableSection minPadded">

               <div className="container flex1 innerCenterDiv">
                   <div className="container flex1">
                       <div className="medicationsAvailableIconPanel container">
                        <img src={props.medicationsAvailable.icon} className="medicationsAvailableSectionTitleIcon" alt="medications available icon" />
                       </div>
                       <div className="container vertical" style={{flex: 10}}>
                          <div className="medicationsAvailableSectionHeader container vertical-center">
                             Medications Available
                          </div>

                          <div className="medicationsAvailableSectionValues container vertical wrap">
                             {props.medicationsAvailable.options.map((medication, index) => {
                                 if(!props.location.attributes[medication.groupId]){
                                     return null;
                                 }
                                 if(_.contains(props.location.attributes[medication.groupId].choice || [], medication.optionId)){
                                     return (<div className="medicationsAvailableSectionItem" key={"medication-" + index}>{medication.name}</div>)
                                 }
                                 return null;
                             })}
                          </div>
                       </div>

                   </div>
               </div>
               <div className="container flex1 innerCenterDiv">
                   <div className="container flex1 practiceSpecialtyContainer">
                       <div className="medicationsAvailableIconPanel container">
                        <img src={props.practiceSpecialty.icon} className="medicationsAvailableSectionTitleIcon" alt="medications available icon"/>
                       </div>
                       <div className="container vertical wrap flex1"  >
                              <div className="medicationsAvailableSectionHeader container vertical-center">
                                Practice Specialty
                             </div>
                             <div className="medicationsAvailableSectionValues container vertical wrap">
                                {props.location.attributes[attributeIds.practiceSpecialty] ?
                                    props.practiceSpecialty.options.map((specialty, index) => {
                                        var choices = props.location.attributes[attributeIds.practiceSpecialty].choice;
                                        if(_.contains(choices, specialty.optionId)){
                                            return (<div className="medicationsAvailableSectionItem" key={"specialty-" + index}>{specialty.name}</div>)
                                        }
                                        return null;
                                    })
                                    :
                                    <div style={{fontFamily: "Lato", fontSize: "16px", color: "#1c5c7f"}}>This information is not yet available</div>
                                }
                              </div>

                       </div>

                   </div>
               </div>


        </div>

       )
}

export default MedicationsAvailableDetailWidget;



// WEBPACK FOOTER //
// ./src/components/locator/details/MedicationsAvailableDetailWidget.js